import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';

export const Error = () => {
  return (
    <>
      <Header />
      <div className="w-96 mx-auto my-20">
        <h1 className="text-4xl text-center">404 Page Not found</h1>
        <h2 className="text-2xl text-center mt-4">Can't Find Your Page</h2>
      </div>
      <Footer />
    </>
  )
}